import React, { Component } from 'react';

class InContextResumeBookingButtonHelpContent extends Component {
    render() {
        return (
            <div className="in-context-resume-booking-button-help-content">
                <p>
                    The <i>resume booking</i> button can be aligned to the right, left, or center of the screen;
                    the button sits relative to the screen’s bottom edge.
                </p>
                <p>
                    To control where the button sits, you can adjust the distance from the screen’s
                     bottom edge by entering a <code>rem</code> value, a relative unit of length based on a root font size of <code>16px</code>.
                </p>
                <ul className='spark-pad-l-.5'>
                    <li>
                        <code>.5rem</code> = <code>8px</code> (button sits very close to bottom edge)
                    </li>
                    <li>
                        <code>1rem</code> = <code>16px</code> (button sits close to bottom edge, leaving minimal space)
                    </li>
                    <li>
                        <code>2rem</code> = <code>32px</code> (standard, comfortable position)
                    </li>
                    <li>
                        <code>3rem</code> = <code>48px</code> (pushes button up, useful when additional bottom UI elements are present)
                    </li>
                    <li>
                        <code>5rem</code> = <code>80px</code> (button sits well above bottom edge; useful for extra breathing room)
                    </li>
                </ul>
                <p>
                    Because <code>rem</code> values scale with the root font size, the button's position remains proportional across
                    different devices and user font-size preferences, ensuring a consistent and accessible guest experience.
                </p>
            </div>
        );
    }
}

export default InContextResumeBookingButtonHelpContent;



// WEBPACK FOOTER //
// ./src/components/pages/pages/product/InContextResumeBookingButtonHelpContent.js